<template lang="pug">
div
  el-row(v-if="!isBeneficiario")
    el-row(:span="24").marginTop
      el-col(:span="12")
        app-display(
          label="Tipo de cadastro:",
          :content="tipo",
        )
      el-col(:span="12")
        app-display(
          label="Data de cadastro:",
          :content="this.dataCadastro",
        )
      el-col(:span="12",v-if="dataRetificacao")
        app-display(
          label="Data de retificação:",
          :content="this.dataRetificacao",
        )
  el-row
    app-divider(label="Qualificação", v-if="qualificacao && !isProcessoFisico")
  el-row.marginTop
    el-col(v-if="qualificacao && !isProcessoFisico", :span="24")
      .margem
        app-display(
          :label="labelQualificacao.area",
          :content="formatterDecimal(qualificacao.area) + ' hectare(s)'",
          :class = "compararQualificacao && compararQualificacao.mudouArea ? 'text': '' "
        )
        app-display(
          v-if="qualificacao.municipio"
          label="Município:",
          :content="qualificacao.municipio.nome"
          :class = "compararQualificacao && compararQualificacao.mudouMunicipio ? 'text': '' "
        )
        app-display(
          v-if="!isBahia"
          label="Qual a renda familiar?",
          :content="renda",
          :class = "compararQualificacao && compararQualificacao.mudouRenda ? 'text': '' "
        )
        app-display(
          :label="labelQualificacao.cargoPublico",
          :content="qualificacao.cargoPublico ? 'Sim' : 'Não'",
          :class = "compararQualificacao && compararQualificacao.mudouCargoPublico ? 'text': '' "
        )
        app-display(
          :label="labelQualificacao.possuiImovelRuralTitulado",
          :content="qualificacao.possuiImovelRuralTitulado ? 'Sim' : 'Não'",
          :class = "compararQualificacao && compararQualificacao.mudouPossuiImovelRuralTitulado ? 'text': '' "
        )
        app-display(
          v-if="qualificacao.possuiImovelRuralTitulado"
          :label="labelQualificacao.tamanhoImovelTitulado",
          :content="formatterDecimal(qualificacao.tamanhoImovelTitulado) + ' hectare(s)'",
        )
        app-display(
          :label="isMunicipioIlha(cadastroOriginal) ? labelQualificacao.ocupaImovelIlha : labelQualificacao.ocupaImovel",
          :content="qualificacao.ocupaImovel ? 'Sim' : 'Não'",
          :class = "compararQualificacao && compararQualificacao.mudouOcupaImovel ? 'text': '' "
        )
        app-display(
          v-if="!isBahia"
          :label="labelQualificacao.exploracaoAgricola",
          :content="qualificacao.exploracaoAgricola ? 'Sim' : 'Não'",
          :class = "compararQualificacao && compararQualificacao.mudouExploracaoAgricola ? 'text': '' "
        )
        app-display(
          v-if="isBahia"
          :label="labelQualificacao.naturezaGlebaPretendida",
          :content="qualificacao.situacaoGleba ? 'Sim' : 'Não'",
        )
        app-display(
          label="Situação: ",
          :content="getSituacao",
          v-if="cadastroOriginal.tipo==='PEAS'"
        )
        span.pessoas Lista de pessoas que acompanham o processo
          div.viewPersonInfo(v-for="(pessoa, index) in pessoas" :key="index")
            span.text {{pessoa.nomeRazaoSocial}}
            span.text {{pessoa.documento ? pessoa.documento.nome : ''}}
            el-tooltip(
              effect='dark',
              content='Baixar arquivo',
              placement="top"
            )
              button.buttonDocument(
                v-if="pessoa.documento"
                @click="getDownload(pessoa.documento)"
              )
                font-awesome-icon(icon="download", size="lg")
</template>

<script>
import FileSaver from 'file-saver'
import axios from '@/utils/api'
import AppDisplay from './../AppDisplay'
import AppDivider from '@/components/AppDivider'
import utils from '@/utils/utils'
import compararReticacoesDefault from '../../utils/pa/compararReticacoesDefault'
const { labelVisualizacaoProcesso, rendaEnum } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppDisplay,
    AppDivider
  },
  props: {
    qualificacao: {
      type: Object,
      required: false
    },
    tipo: {
      type: String,
      default: '-'
    },
    dataCadastro: {
      type: String,
      default: null
    },
    isBeneficiario: {
      type: Boolean,
      required: false,
      default: false
    },
    cadastroOriginal: {
      type: Object,
      required: true
    },
    pessoas: {
      type: Array,
      required: true
    },
    compararQualificacao: {
      type: Object,
      default: compararReticacoesDefault.mudouQualificacaoDTODefault
    },
    dataRetificacao: {
      type: String,
      default: null
    },
    isProcessoFisico: {
      type: Boolean,
      required: false,
      default: false
    },
    idProcesso: {
      type: Number,
      require: true
    }
  },

  computed: {

    renda () {
      return rendaEnum[this.qualificacao.renda]
    },

    getSituacao () {
      if ((Number(this.qualificacao.area)) <= 100 &&
        this.qualificacao.renda !== 'mais5' &&
        !this.qualificacao.cargoPublico &&
        !this.qualificacao.possuiImovelRuralTitulado &&
        this.qualificacao.ocupaImovel &&
        this.qualificacao.exploracaoAgricola) {
        return 'Apto'
      }
      return 'Não Apto'
    },

    isBahia () {
      return process.env.ESTADO === 'ba'
    }
  },

  methods: {
    isMunicipioIlha (cadastro) {
      return cadastro?.imovel?.municipio?.id ? utils.municipiosIlha(cadastro?.imovel?.municipio?.id) : false
    },
    formatterDecimal (value) {
      return utils.format(value, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision: 4 })
    },
    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    }
  },

  data () {
    return {
      labelQualificacao: labelVisualizacaoProcesso.etapaQualificacao,
      isReurbIndividual: this.tipo === 'REURB individual',
      isMA: process.env.ESTADO === 'ma'
    }
  }
}
</script>

<style lang="scss" scoped>
  .margem {
    margin-left: 6px;
  }
  .marginTop {
    padding-top: 15px;
  }
  .pessoas{
    font-weight: bold;
    font-size: 14px;
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  >>> .text .text{
    color: #ff0000 !important;
  }
  .viewPersonInfo{
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .text{
    font-size: 14px;
    width: 40%;
  }
  .buttonDocument{
    border: none;
    background: none;
    padding: 0;
    width: 20%;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/informacoesQualificacao.vue